import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './features1440px.module.scss';
import { Features1440pxType } from '@/types/featuresBlock.types';

const FeaturesBlock: NextPage<Features1440pxType> = ({
  className = '',
  name,
  text,
  items = [],
  image,
  imageMob,
  pressToTop,
}) => {
  return (
    <section className="container">
      <div className={[styles.features1440px, className].join(' ')}>
        <section
          className={pressToTop ? styles.containerCentered : styles.container}
        >
          <div className={styles.leftcol}>
            {name && (
              <h2
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: name }}
              />
            )}
            <div className={styles.descriptor}>
              {text && (
                <p
                  className={styles.text}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              )}
            </div>
            <div className={styles.items}>
              {items.map((item) => (
                <div key={item.id} className={styles.itemBlock}>
                  <Image
                    className={styles.icon}
                    width={24}
                    height={24}
                    sizes="100vw"
                    alt=""
                    src="/img/features/check-img.png"
                  />
                  <div
                    className={styles.text}
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
          <Image
            className={styles.imageIcon}
            loading="lazy"
            width={470}
            height={422}
            sizes="100vw"
            alt=""
            src={image}
          />
          <Image
            className={styles.imageIcon1}
            width={400}
            height={184.7}
            sizes="100vw"
            alt=""
            src={imageMob}
          />
        </section>
      </div>
    </section>
  );
};

export default FeaturesBlock;
